// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3mAZP","subheader":"ReorderModal_subheader__2cAd7","listWrap":"ReorderModal_listWrap__1YmcA"};